
<!-- <mat-card *ngFor="let request of showing.showingConfirmationRequest" >
	<mat-card-title>{{showing.property.address.fullAddress}}</mat-card-title>
	<mat-card-subtitle>{{ requestStatus(request) }}</mat-card-subtitle>
	<mat-card-content>
	</mat-card-content>
</mat-card> -->
<mat-card>
	<mat-card-title>{{ showing?.property?.address?.fullAddress }}</mat-card-title>
</mat-card>